import {
  AttachMoneyRounded,
  CheckBoxRounded,
  HorizontalRule,
  Image,
  InsertInvitationRounded,
  PlayCircleFilled,
  RadioButtonCheckedRounded,
  Title,
} from '@mui/icons-material';
import { ElementType } from 'features/document/constants';
import { ReactComponent as DropdownIcon } from 'assets/images/ContentBlockIcons/dropdown-content-block-icon.svg';
import { ReactComponent as SignatureIcon } from 'assets/images/ContentBlockIcons/signature-content-block-icon.svg';
import { ReactComponent as SpacerIcon } from 'assets/images/ContentBlockIcons/spacer-content-block-icon.svg';
import { ReactComponent as TableIcon } from 'assets/images/ContentBlockIcons/table-content-block-icon.svg';
import { ReactComponent as TextFieldIcon } from 'assets/images/ContentBlockIcons/text-field-content-block-icon.svg';
import { ReactComponent as InitialsIcon } from 'assets/images/ContentBlockIcons/initials-content-block-icon.svg';
import { ReactComponent as ApprovalIcon } from 'assets/images/ContentBlockIcons/approval-content-block-icon.svg';
import { ReactComponent as ContractInfoTableIcon } from 'assets/images/ContentBlockIcons/project-info-table-content-block-icon.svg';
import { ReactComponent as SendToIcon } from 'assets/images/ContentBlockIcons/send-to-content-block-icon.svg';
import { ReactComponent as BillToIcon } from 'assets/images/ContentBlockIcons/bill-to-content-block-icon.svg';
import { ReactComponent as ContactInfoIcon } from 'assets/images/ContentBlockIcons/contact-info-content-block-icon.svg';
import { docGeniusPalette } from 'styles/partials/colors';

const getIconStyle = (isMUIIcon: boolean) => ({
  width: '40px',
  height: '40px',
  ...(isMUIIcon && { color: docGeniusPalette.cardDndAccentblue.toString() }),
});

export const generalIconList = [
  {
    icon: <Title sx={getIconStyle(true)} />,
    title: 'Text',
    type: ElementType.Text,
  },
  {
    icon: <Image sx={getIconStyle(true)} />,
    title: 'Image',
    type: ElementType.Image,
  },
  {
    icon: <PlayCircleFilled sx={getIconStyle(true)} />,
    title: 'Video',
    type: ElementType.Video,
  },
  {
    icon: <TextFieldIcon style={getIconStyle(false)} />,
    title: 'Text Field',
    type: ElementType.TextField,
  },
  {
    icon: <InsertInvitationRounded sx={getIconStyle(true)} />,
    title: 'Date',
    type: ElementType.Date,
  },
  {
    icon: <SpacerIcon style={getIconStyle(false)} />,
    title: 'Spacer',
    type: ElementType.Spacer,
  },
  {
    icon: <HorizontalRule sx={getIconStyle(true)} />,
    title: 'Divider',
    type: ElementType.Divider,
  },
  {
    icon: <CheckBoxRounded sx={getIconStyle(true)} />,
    title: 'Checkbox',
    type: ElementType.CheckBox,
  },
  {
    icon: <RadioButtonCheckedRounded sx={getIconStyle(true)} />,
    title: 'Radio Button',
    type: ElementType.RadioButton,
  },
  {
    icon: <DropdownIcon style={getIconStyle(true)} />,
    title: 'Dropdown',
    type: ElementType.Dropdown,
  },
  {
    icon: <TableIcon style={getIconStyle(false)} />,
    title: 'Table',
    type: ElementType.Table,
  },
  {
    icon: <SignatureIcon style={getIconStyle(true)} />,
    title: 'Signature',
    type: ElementType.Signature,
  },
  {
    icon: <InitialsIcon style={getIconStyle(true)} />,
    title: 'Initials',
    type: ElementType.Initials,
  },
];

export const contractIconList = [
  {
    icon: <ContractInfoTableIcon style={getIconStyle(true)} />,
    title: 'Contract Info Table',
    type: ElementType.ContractInfoTable,
  },
  {
    icon: <ApprovalIcon style={getIconStyle(true)} />,
    title: 'Approval',
    type: ElementType.ApprovalTable,
  },
];

export const quoteIconList = [
  {
    icon: <BillToIcon style={getIconStyle(true)} />,
    title: 'Bill To',
    type: ElementType.BillTo,
  },
  {
    icon: <SendToIcon style={getIconStyle(true)} />,
    title: 'Ship To',
    type: ElementType.ShipTo,
  },
  {
    icon: <ContactInfoIcon style={getIconStyle(true)} />,
    title: 'Contact Info',
    type: ElementType.ContactInfo,
  },
  {
    icon: <AttachMoneyRounded sx={getIconStyle(true)} />,
    title: 'Pricing Table',
    type: ElementType.PricingTable,
  },
  {
    icon: <ApprovalIcon style={getIconStyle(true)} />,
    title: 'Acceptance Info',
    type: ElementType.QuoteAcceptanceInfoTable,
  },
];
